const profile = {
  name: 'Parvin Malekzadeh',
  // title: 'Postdoctoral Fellow, Rotman School of Management, University of Toronto',
  about: `<p>Hi! I'm a Postdoctoral Fellow in Operations Management & Statistics at the Rotman School of Management, University of Toronto, supervised by <a href="https://discover.research.utoronto.ca/10004" target="_blank">Prof. Opher Baron</a> and <a href="https://discover.research.utoronto.ca/7243-dmitry-krass" target="_blank">Prof. Dmitry Krass</a>.</p>
  <p>My research lies at the intersection of machine learning, optimization, and operational systems, with a focus on reinforcement learning for optimizing automated queue‑management and operational systems, particularly within healthcare settings. I'm passionate about advancing autonomous AI to support real‑world decision‑making.</p>
  <p>Prior to this, I earned my Ph.D. in the Edward S. Rogers Sr. Department of Electrical & Computer Engineering at the University of Toronto, under the supervision of <a href="https://www.dsp.utoronto.ca/~kostas/" target="_blank">Prof. Kostas Plataniotis</a>.</p>`,
  profileImage: process.env.PUBLIC_URL + '/images/pmalek2.jpg',
  email: 'p.malekzadeh@mail.utoronto.ca',
  social: [
    { icon: 'github', url: 'https://github.com/pmalekzadeh' },
    { icon: 'linkedin', url: 'http://www.linkedin.com/in/parvin-malekzadeh-b1364014a' },
    { icon: 'email', url: 'mailto:p.malekzadeh@mail.utoronto.ca' },
    { icon: 'scholar', url: 'https://scholar.google.com/citations?hl=en&user=zHoFtSIAAAAJ' },
  ],
  skills: [
    'Reinforcement Learning', 'Deep Learning', 'LLM', 'Generative Models', 'Uncertainty-Aware Decision Making', 'Healthcare Analytics and Decision Support Systems', 'Optimization', 'Queueing Theory',  
    'Statistics'
  ],
  awards: [
    {
      title: "TD Management Data and Analytics Lab Research Grant ($3,000)",
      organization: "University of Toronto",
      year: "2025",
      category: "Academic Excellence",
      description: ""
    },
    {
      title: "Nominated for the Best Ph.D. Dissertation Award",
      organization: "University of Toronto",
      year: "2024",
      category: "Academic Excellence",
      description: "Recognized for outstanding doctoral research in Electrical and Computer Engineering."
    },
    // {
    //   title: "Best Master's Thesis Award",
    //   organization: "Concordia University",
    //   year: "2020",
    //   category: "Research Excellence",
    //   description: "Awarded $10,000 for exceptional master's thesis research."
    // },
    {
      title: "Graduate Entrance Awards",
      organization: "Concordia University",
      year: "2018",
      category: "Academic Excellence",
      description: "Received $5,000 for outstanding academic achievements upon graduate program admission."
    },
    {
      title: "Iran's National Elites Foundation (INEF) Grant",
      organization: "Iran",
      year: "2013-2017",
      category: "Academic Excellence",
    },
    {
      title: "Iranian University Entrance Exam Achievement",
      organization: "Iran",
      year: "2013",
      category: "Academic Excellence",
      description: "Ranked 1st among 50,000 participants in the highly competitive national university entrance exam (Konkour)."
    },
    {
      title: "Iran National Mathematics Olympiad",
      organization: "Iran",
      year: "2012",
      category: "Academic Competition",
      description: "Achieved semi-finalist status in the national mathematics competition."
    }
  ],
  research: 
  [
    {
      title: "Digital twin for automated ed systems innovative decision support system for policymakers.",
      authors: "P. Malekzadeh, O. Baron, D. Krass, and A. Senderovich",
    },
    {
      title: "Shift effect in physician effort allocation in emergency departments with patient abandonment",
      authors: "P Malekzadeh, O Baron, S He, D Krass, A Senderovich, H Yuan",
    },
    {
      title: "Reinforcement learning for optimizing physician effort allocation in emergency departments",
      authors: "P. Malekzadeh, O. Baron, D. Krass, and A. Senderovich",
    },
    {
      title: "A unified inference on continuous spaces partially observable markov decision processes",
      authors: "P Malekzadeh, K. N. Plataniotis. (Book manuscript, to be submitted to MIT Press)",
    },
    {
      title: "Bayesian adversarial modeling for distributional reinforcement learning",
      authors: "P Malekzadeh, K. N. Plataniotis",
    }
  ],
  
  publications: [
    {
      title: "Active Inference and Reinforcement Learning: A Unified Inference on Continuous State and Action Spaces under Partial Observability",
      authors: "P Malekzadeh, KN Plataniotis",
      venue: "Neural Computation, 2024",
      image: process.env.PUBLIC_URL + "/images/Inference.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2212.07946.pdf" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/UnifiedInference/index.html" }
      ]
    },
    {
      title: "EX-DRL: Hedging Against Heavy Losses with EXtreme Distributional Reinforcement Learning",
      authors: "P Malekzadeh, Z Poulos, J Chen, Z Wang, KN Plataniotis",
      venue: "Proceedings of the 5th ACM International Conference on AI in Finance, 2024",
      image: process.env.PUBLIC_URL + "/images/EX-DRL.png",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2408.12446" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/EX-DRL/index.html" },
        { label: "code", url: "https://github.com/pmalekzadeh/EX-DRL" }
      ]
    },
    {
      title: "UaMB-SF: Uncertainty-aware transfer across tasks using hybrid Model-Based Successor Feature reinforcement learning",
      authors: "P Malekzadeh, M Hou, KN Plataniotis",
      venue: "Neurocomputing, 2023",
      image: process.env.PUBLIC_URL + "/images/SF-MB2.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2310.10818.pdf" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/UaMB-SF/index.html" }
      ]
    },
    {
      title: "A Robust Quantile Huber Loss with Interpretable Parameter Adjustment in Distributional Reinforcement Learning",
      authors: "P Malekzadeh, KN Plataniotis, Z Poulos, Z Wang",
      venue: "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), 2024",
      image: process.env.PUBLIC_URL + "/images/loss.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2401.02325.pdf" },
        { label: "code", url: "https://github.com/pmalekzadeh/A-robust-quantile-huber-loss" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/RobusLossFunction/index.html" }
      ]
    },
    {
      title: "AKF-SR: Adaptive Kalman filtering-based Successor Representation",
      authors: "P Malekzadeh, M Salimibeni, M Hou, A Mohammadi, KN Plataniotis",
      venue: "Neurocomputing, 2022",
      image: process.env.PUBLIC_URL + "/images/AKF-SR2.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2204.00049.pdf" },
        { label: "code", url: "https://github.com/pmalekzadeh/AKF-SR" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/AKF-SR/index.html" }
      ]
    },
    {
      title: "UUaE: A Unified Uncertainty-aware Exploration combining epistemic and aleatory uncertainty",
      authors: "P Malekzadeh, M Hou, KN Plataniotis",
      venue: "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), 2023",
      image: process.env.PUBLIC_URL + "/images/Uncertainty.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2401.02914.pdf" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/UUaE/index.html" }
      ]
    },
    {
      title: "MM-KTD: Multiple Model Kalman Temporal Differences for reinforcement learning",
      authors: "P Malekzadeh, M Salimibeni, A Mohammadi, A Assa, KN Plataniotis",
      venue: "IEEE Access, 2020",
      image: process.env.PUBLIC_URL + "/images/MM-KTD.jpg",
      links: [
        { label: "paper", url: "https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=9136644" },
        { label: "code", url: "https://github.com/pmalekzadeh/MM-KTD" }
      ]
    }
  ],
  timeline: [
    // {
    //   date: "2024–Present",
    //   title: "Postdoctoral Fellow in Operations Management and Statistics",
    //   org: "Rotman School of Management, University of Toronto",
    //   location: "Toronto, Canada",
    //   logo: process.env.PUBLIC_URL + "/images/rotman.png"
    // },
    {
      date: "2020–2024",
      title: "Ph.D. in Electrical and Computer Engineering",
      org: "University of Toronto",
      location: "Toronto, Canada",
      logo: process.env.PUBLIC_URL + "/images/uoft.webp"
    },
    {
      date: "2018–2020",
      title: "M.Sc. in Electrical and Computer Engineering",
      org: "Concordia University",
      location: "Montreal, Canada",
      logo: process.env.PUBLIC_URL + "/images/concordia.png"
    },
    {
      date: "2013–2018",
      title: "B.Sc. in Electrical and Computer Engineering",
      org: "Sharif University of Technology",
      location: "Tehran, Iran",
      logo: process.env.PUBLIC_URL + "/images/sharif.png"
    }
  ],
  experience: [
    {
      title: "AI Researcher",
      organization: "SiMLQ",
      location: "Toronto, Canada",
      period: "Oct. 2024 - Present",
      description: "Developing machine learning models to optimize queue-management systems in emergency departments."
    },
    {
      title: "LLM Developer",
      organization: "Extropolis AI",
      location: "Remote",
      period: "July 2024 - Nov. 2024",
      description: "Designed LLM-powered autonomous agents (Agentic LLMs) to enhance task efficiency, adaptability, and user interaction in real-world applications."
    },
    {
      title: "AI Researcher",
      organization: "Rotman's FinHub",
      location: "Toronto, Canada",
      period: "May 2023 - Aug. 2024",
      description: "Modeled financial markets and conducted literature reviews to develop risk-aware reinforcement learning solutions for hedging risk."
    },
    {
      title: "AI Researcher",
      organization: "Dormakaba",
      location: "Montreal, Canada",
      period: "Jan. 2019 - Jan. 2021",
      description: "Conducted literature reviews and developed machine learning models to enhance the security of electronic access systems using mobile Bluetooth signals."
    }
  ],
  teaching: {
    instructor: [
      {
        period: "Winter 2026",
        organization: "University of Toronto",
        courses: [
          {
            title: "Reinforcement Learning",
            location: "Rotman School of Management, University of Toronto"
          }
        ]
      },
      {
        period: "Winter 2026",
        organization: "York University",
        courses: [
          {
            title: "Predictive Analytics",
            location: "Schulich School of Business, York University"
          }
        ]
      },
      {
        period: "Summer 2023",
        organization: "Queen's College of Business, Technology & Public Safety",
        courses: [
          {
            title: "Python Coding"
          }
        ]
      }
    ],
    teachingAssistant: [
      {
        organization: "University of Toronto",
        period: "2020 - Present",
        courses: [
          {
            title: "Special Topics in Management (RSM415H1)",
            period: "2024 - Present"
          },
          {
            title: "Service Analytics for Management Analysis (RSM8415H)",
            period: "2024 - Present"
          },
          {
            title: "Healthcare Analytics (RSM8416H)",
            period: "2024 - Present"
          },
          {
            title: "Adaptive Control and Reinforcement Learning (ECE411)",
            period: "2022 - Present"
          },
          {
            title: "Neural Networks and Deep Learning (CSC413)",
            period: "2023 - 2024"
          },
          {
            title: "Probability and Applications (ECE302)",
            period: "2020 - 2024",
            note: "Head Teaching Assistant"
          },
          {
            title: "Numerical Algorithms for Mathematics (CSCC37)",
            period: "2021 - 2022"
          }
        ]
      }
    ]
  },
  seminars: [
    {
      year: "2025",
      month: null,
      title: "Reinforcement Learning for Optimizing Physician Effort Allocation in Emergency Departments",
      conferences: [
        "2025 Annual Canadian Celebration of Women in Computing (CAN-CWiC), Toronto, Canada.",
        "2025 INFORMS Annual Meeting, Atlanta, USA.",
        "25th edition of the CanQueue workshop, London, Canada",
        "The 18th INFORMS Computing Society Conference (ICS), Toronto, Canada"
      ]
    },
    {
      year: "2025",
      month: "Oct.",
      title: "Reinforcement Learning in Action: From Games to Operational Research",
      conferences: [
        "3rd year Engineering Science Seminar course, University of Toronto"
      ]
    },
    {
      year: "2025",
      month: "Jun.",
      title: "Shift Effect and Its Impact in Emergency Departments: From Analytical Insights to Empirical Validation",
      conferences: [
        "66th Annual Conference of the Canadian Operational Research Society (CORS), Edmonton, Canada",
        "8th Annual Research Roundtable: Data Analytics in Healthcare, Toronto, Canada"
      ]
    },
    {
      year: "2024",
      month: "July",
      title: "Active Inference and Reinforcement Learning: A Unified Inference on Continuous State and Action Spaces under Partial Observability",
      conferences: [
        "CIFAR Deep Learning + Reinforcement Learning (DLRL) Summer School, Toronto, Canada"
      ]
    },
    {
      year: "2024",
      month: "Apr.",
      title: "A Robust Quantile Huber Loss With Interpretable Parameter Adjustment in Distributional Reinforcement Learning",
      conferences: [
        "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), Seoul, Korea"
      ]
    },
    {
      year: "2023",
      month: "June",
      title: "UUaE: A Unified Uncertainty-aware Exploration combining Epistemic and Aleatory Uncertainty",
      conferences: [
        "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), Virtual"
      ]
    }
  ]
};

export default profile; 